import { render, staticRenderFns } from "./ParticipateInActivities.vue?vue&type=template&id=f24883d4&scoped=true"
import script from "./ParticipateInActivities.vue?vue&type=script&lang=ts"
export * from "./ParticipateInActivities.vue?vue&type=script&lang=ts"
import style0 from "./ParticipateInActivities.vue?vue&type=style&index=0&id=f24883d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24883d4",
  null
  
)

export default component.exports